import { Component } from '@angular/core';

import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { MapToolsService } from '../workspace/map-tools.service';
import { PageEditorService } from '../workspace/page-editor.service';
import { PagePublisherService } from '../workspace/page-publisher.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { SubRegionsService } from '../workspace/subregions.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';
import { GateSummary, gateOf } from './suburb-facts';

/**
 * One sub-region's panel (#260; plan §6.5): its members (each can be taken out, or edited on the map), its website
 * page (Publish, Un-publish, Edit), Fill from council areas, its search gate, its colour, and Delete.
 */
@Component({
  selector: 'app-suburb-subregion-panel',
  templateUrl: './suburb-subregion-panel.component.html',
  styleUrls: ['./suburb-subregion-panel.component.scss'],
})
export class SuburbSubRegionPanelComponent {
  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public subRegions: SubRegionsService,
    public publisher: PagePublisherService,
    public pageEditor: PageEditorService,
    public mapTools: MapToolsService,
    public nav: PanelNavService
  ) {}

  /** The open sub-region (the panel only shows for one). */
  get id(): string {
    return this.subRegions.openId ?? '';
  }

  get gate(): GateSummary | null {
    return gateOf(this.subRegions.detail);
  }
}
